import { createTheme } from '@material-ui/core/styles';
import { green, red } from '@material-ui/core/colors';

const rawTheme = createTheme({
  palette: {
      primary: {
        light: '#c3eb61',
        main: '#99d700',
        dark: '#65880e',
      },
      secondary: {
        light: '#ff072e',
        main: '#d50022',
        dark: '#660312',
      },
      warning: {
        main: '#910c21',
        dark: '#660312',
      },
      error: {
        xLight: red[50],
        main: red[500],
        dark: red[700],
      },
      success: {
        xLight: green[50],
        main: green[500],
        dark: green[700],
      },
      type: 'dark',
      background: {
        default: "#242424"
      }
    },
    typography: {
      fontFamily: "'Poppins', sans-serif",
      fontSize: 14
    },
    props: {
      MuiTab: {
        disableRipple: true,
      },
    }
  });

const theme = {
  ...rawTheme,
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: '#1c1c1c',
      },
    },
    MuiButton: {
      label: {
        textTransform: 'none',
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: rawTheme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: rawTheme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        margin: '0 16px',
        minWidth: 0,
        padding: 0,
        [rawTheme.breakpoints.up('md')]: {
          padding: 0,
          minWidth: 0,
        },
      },
    },
    MuiIconButton: {
      root: {
        padding: rawTheme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#454545',
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: rawTheme.typography.fontWeightMedium,
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        marginRight: 0,
        '& svg': {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
    MuiBox:{
      root: {
        padding: 0
      },
    }, 
    
  },
};

export default theme;
